// extracted by mini-css-extract-plugin
export var goBackLink = "previous-blog-posts-module--go-back-link--bb2RN";
export var header = "previous-blog-posts-module--header--nVOv-";
export var mvpBanner = "previous-blog-posts-module--mvp-banner--KEmb1";
export var newsletterBanner = "previous-blog-posts-module--newsletter-banner--x+44A";
export var postsContainer = "previous-blog-posts-module--posts-container--cKA8Q";
export var section = "previous-blog-posts-module--section--Wamaq";